module.exports = __webpack_public_path__ + "static/media/rotate.79235707.svg";